import { Box, Stack } from '../../../shared/layouts';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';
import Card from '../../../shared/Card';
import DisplayLine from '../../../shared/DisplayLine';
import { formatISODate } from '../../../../utils/dateHelpers';
import { useTranslation } from 'react-i18next';
import Header from '../../../shared/Header';
import ConfirmedIcon from 'imagesUwKluis/svg/confirmed.svg';
import Button from "../../../shared/Button";
import {useContext} from "react";
import MessagebarContext from "../../../../context/MessagebarContext";

const ResultSection = ({
  description,
  created_at,
  completed_at,
  requestId,
  sourceType
}) => (
  <>
    <InfoSection sourceType={sourceType} />
    <DataSection
      description={description}
      created_at={created_at}
      completed_at={completed_at}
      requestId={requestId}
    />
  </>
);

const InfoSection = ({ sourceType }) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  return (
    <Card>
      <Stack space={isMinDesktop ? 'l' : 'm'}>
        <Header
          icon={<ConfirmedIcon height={'32px'} width={'32px'} />}
          button={isMinDesktop && sourceType.logo}
          title={t('Gegevens zijn verstuurd')}
          variant="section"
          width={'100%'}
        />
        <p>
          <strong>{t('Het is gelukt!')}</strong>
          <br />
          {t(
            'De benodigde gegevens zijn opgehaald en gedeeld met je financieel dienstverlener. Je kunt de PDF met het overzicht downloaden door op de download knop te klikken.'
          )}
        </p>
      </Stack>
    </Card>
  );
};

const DataSection = ({ description, created_at, completed_at, requestId }) => {
  const { t } = useTranslation();
  const { setCustomMessage } = useContext(MessagebarContext);
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  return (
    <Card>
      <Stack space={isMinDesktop ? 'm' : 's'}>
        <DisplayLine label={t('Beschrijving')} value={description} />
        <DisplayLine
          label={t('Ontvangen op')}
          value={formatISODate(created_at)}
        />
        <DisplayLine
          label={t('Status')}
          value={completed_at ? t('Gedeeld') : t('Openstaand')}
        />
        <DisplayLine
          label={t('Gedeeld op')}
          value={formatISODate(completed_at)}
        />
        {isMinDesktop ? (
          <Box
            css={{
              position: 'relative',
              overflow: 'hidden',
              width: '100%',
              paddingTop: '140%'
            }}
          >
            <iframe
              src={`/source-data/${requestId}/show.pdf`}
              height="100%"
              width="100%"
              css={{
                position: 'absolute',
                top: 0,
                left: 0
              }}
            />
          </Box>
        ) : (
          <Button
            width={'100%'}
            onClick={() => {
              window.location.href = `/source-data/${requestId}/download`;
              setCustomMessage(
                t('De download is gestart. Een moment geduld.')
              );
            }}
          >
            {t('Download brondata')}
          </Button>
        )}

      </Stack>
    </Card>
  );
};

export default ResultSection;
